import React, { useState } from 'react';
import Modal from '../../../components/modal-x';
import { Button, Input, Textarea } from '@material-tailwind/react';
import { useUpdateContractWithCompletedBookings } from '../../../custom-hooks/use-contracts';
import { CalendarClockIcon } from 'lucide-react';

const ContractTerminateModal = ({ isOpen, onClose, data }) => {
    const { _id, endDate: endDateFromData } = data;

    const [endDate, setEndDate] = useState(endDateFromData || '');
    const [reason, setReason] = useState('');
    const [error, setError] = useState(null);
    const updateContractMutation = useUpdateContractWithCompletedBookings();


    const handleTerminate = async (e) => {
        e.preventDefault();
        try {
            const payload = {
                endDate: new Date(endDate),
                reason
            }
            await updateContractMutation.mutateAsync({
                contractId: _id,
                data: payload
            });
            onClose();
        } catch (error) {
            console.log(error);
            setError(error.message);
        }
    }

    return <Modal
        title="Terminate Contract"
        isOpen={isOpen}
        onClose={onClose}
    >
        <form onSubmit={handleTerminate}>
            <div className='flex flex-col gap-4'>
                <Input label='End Date' type='date' required value={endDate} onChange={(e) => setEndDate(e.target.value)} />
                <Textarea label='Reason' required type='text' value={reason} onChange={(e) => setReason(e.target.value)} />
                {error && <p className='text-red-500'>{error}</p>}
                <Button
                    className='w-full rounded-full flex items-center justify-center gap-2'
                    variant='filled'
                    color='amber'
                    type='submit'
                    disabled={updateContractMutation.isLoading}
                    loading={updateContractMutation.isLoading}>
                    <CalendarClockIcon className='w-4 h-4' /> Terminate
                </Button>
            </div>
        </form>
    </Modal>
};

export default ContractTerminateModal;